// Modi sind Voreinstellungen ueber Feature-Schaltern. Komponenten fragen
// immer die Schalter ab, nie den Modusnamen.
// Jeder Modus nennt JEDEN Schalter ausdruecklich, auch die ausgeschalteten —
// ein fehlender Schluessel waere undefined und damit stillschweigend false.
export const modes = [
   {
    id: 'kennenlernen',
    label: 'Gerät kennenlernen',
    description: 'Teile und Abläufe des Geräts ansehen.',
    lernziel: 'Ich weiss, wo am Gerät was ist und wie die Abläufe gehen.',
    features: {
        guideAvailable: false,
        guideAutostart: false,
        showTasks: false,
        deviceStartsOn: true,
        showErklaerungen: true,
        sitzung: false
    }
   },
   {

    id: 'lernen',
    label: 'Lernmodus',
    description: 'Das Gerät Schritt für Schritt bedienen lernen.',
    lernziel: 'Ich kann das Gerät Schritt für Schritt bedienen.',
    features: {
        guideAvailable: true,
        guideAutostart: true,
        showTasks: false,
        deviceStartsOn: false,
        showErklaerungen: false,
        sitzung: false
    }

   },
   {
    id: 'anfaenger',
    label: 'Anfänger',
    description: 'Aufgaben ohne Anleitung lösen.',
    lernziel: 'Ich kann Aufgaben am Gerät ohne Anleitung lösen.',
    features: {
        guideAvailable: false,
        guideAutostart: false,
        showTasks: true,
        deviceStartsOn: false,
        showErklaerungen: false,
        sitzung: false
    }
   },
   {
    // Kein Eintrag auf der Trainingsseite: erreichbar nur ueber /sitzung/funk,
    // nach dem Beitreten. Die Aufgaben kommen aus der Sitzung, nicht aus Tasks.js.
    id: 'sitzung',
    label: 'Sitzung',
    description: 'Aufgaben aus der Sitzung deines Ausbildners.',
    lernziel: 'Ich löse die Aufgaben aus der Sitzung am Gerät.',
    features: {
        guideAvailable: false,
        guideAutostart: false,
        showTasks: true,
        deviceStartsOn: false,
        showErklaerungen: false,
        sitzung: true
    }
   }
]
